import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/Services/auth.service';
import { MenuService } from 'src/app/Services';
import { Funcionalidad } from 'src/app/Entities';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent  implements OnInit {
  @Output() onShowModalLogin = new EventEmitter();

  menu: Funcionalidad[] = [];

  constructor(
    private router: Router,
    private authService: AuthService,
    public menuService: MenuService
  ) {

  }

  ngOnInit(): void {
    
  }

  cargarFactura() {
    if (this.authService.authUser && this.authService.authUser.identificador) {
      this.router.navigateByUrl('negocio_documentos/cargar_factura');
    } else {
      this.onShowModalLogin.emit();
    }
  }
}
